<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Driver Owner') }}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="ownerFilter"
              :options="ownersOptions"
              class="w-100"
              :reduce="val => val.id"
              @input="(val) => $emit('update:ownerFilter', val)"
          />
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {

    ownerFilter: {
      type: [Number, null],
      default: null,
    },

    ownersOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
